module.exports = " <a href=javascript:; class=weui_tabbar_item :class=\"{'weui_bar_item_on': $parent.index === index}\" @click=onItemClick> <div class=weui_tabbar_icon :class=\"[iconClass || $parent.iconClass, {'vux-reddot': showDot}]\"> <slot name=icon></slot> <sup><badge v-if=badge :text=badge></badge></sup> </div> <p class=weui_tabbar_label> <slot name=label></slot> </p> </a> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/tabbar/tabbar-item.vue
// module id = 254
// module chunks = 2